import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
        <div className="copyright">
            © Copyright {new Date().getFullYear()} <strong><span>Battersea Web Expert</span></strong>. 
            All Rights Reserved
        </div>
    </footer>
  )
}

export default Footer;